import { IRemedyCategory } from '@lifk/types'

export const defaultRemedyCategory: IRemedyCategory = {
  id: 'default-remedy-category',
  name: { 'en-us': 'Custom', 'es-mx': 'Costumbre' },
  categoryColor: '#fab411',
  sortOrder: 100,
  pillColors: {
    light: { bgColor: '#9b6d03', textColor: '#ffffff' },
    satellite: { bgColor: '#fab411', textColor: '#17181a' }
  },
  footprintStyles: {
    light: {
      color: '#fbc341',
      lineColor: '#fab411',
      draggingOpacity: 0.4,
      placedOpacity: 0.7,
      selectedOpacity: 0.85
    },
    satellite: {
      color: '#9b6d03',
      lineColor: '#fbc341',
      draggingOpacity: 0.4,
      placedOpacity: 0.7,
      selectedOpacity: 0.91
    }
  }
}
